import React, { Component } from 'react'
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import history from '../../core/history';
import Item from './Item';
import { disconnectVerification, resendEmailVerification } from '../../actions/manageUserVerification';
import messages from '../../locale/jsonMessages';

import cs from '../../components/commonStyle.css';
import s from './Trust.css';
class MenuComponent extends React.Component {

  static propTypes = {
    data: PropTypes.shape({
      isEmailConfirmed: PropTypes.bool,
      isFacebookConnected: PropTypes.bool,
      isGoogleConnected: PropTypes.bool,
      isIdVerification: PropTypes.bool,
    }),
    disconnectVerification: PropTypes.any.isRequired,
    account: PropTypes.shape({
      userId: PropTypes.string.isRequired,
    }).isRequired,
    resendEmailLoading: PropTypes.bool,
    formatMessage: PropTypes.any,
  };

  static defaultProps = {
    data: {
      isEmailConfirmed: false,
      isFacebookConnected: false,
      isGoogleConnected: false,
      isIdVerification: 0
    },
    resendEmailLoading: false,
    siteName: PropTypes.string,
  }

  constructor(props) {
    super(props);
    this.sendConfirmEmail = this.sendConfirmEmail.bind(this);
    this.googleDisconnect = this.googleDisconnect.bind(this);
    this.documentVerification = this.documentVerification.bind(this);
  }

  sendConfirmEmail() {
    const { resendEmailVerification } = this.props;
    resendEmailVerification();
  }

  googleDisconnect() {
    const { disconnectVerification, account } = this.props;
    disconnectVerification("google", account.userId);
  }

  documentVerification() {
    history.push('/document-verification');
  }

  render() {
    const { data: { isEmailConfirmed, isGoogleConnected, isIdVerification, pendingEmailChange, pendingEmail }, resendEmailLoading, siteName } = this.props;
    const { formatMessage } = this.props.intl;
    let displayVerifiedPanel = isEmailConfirmed || pendingEmailChange || isGoogleConnected || isIdVerification == 1 || false;
    let displayUnVerifiedPanel = (!isEmailConfirmed && !pendingEmailChange) || !isGoogleConnected || isIdVerification != 1 || false;
    let allUnverified = !isEmailConfirmed && !isGoogleConnected && isIdVerification != 1;
    return (
      <div className={cx(cs.commonBorderSection, 'whiteBgColor')}>
        {
          displayVerifiedPanel && <>
            <h4 className={cx(cs.commonTotalText, cs.fontWeightBold, cs.paddingBottom4)}>{formatMessage(messages.verifiedInfo)}</h4>
            <div className={cx(s.cardSecBg)}>
              {
                isEmailConfirmed && !pendingEmailChange && <Item
                  title={formatMessage(messages.emailLabel)}
                  content={formatMessage(messages.verifiedEmail)}
                  isAction={false}
                  isImage={true}
                  name='email'
                />
              }
              {pendingEmailChange && <Item
                title={formatMessage(messages.emailLabel)}
                content={formatMessage(messages.changeEmailPendingProfile, { email: pendingEmail })}
                isAction
                isLink
                buttonLabel={formatMessage(messages.changeEmailLink)}
                url="/user/change-email"
                name='email'
              />}
              {
                isGoogleConnected && <Item
                  title={formatMessage(messages.google)}
                  content={formatMessage(messages.connectedGoogleInfo)}
                  isAction
                  isLink={false}
                  buttonLabel={formatMessage(messages.disconnect)}
                  handleClick={this.googleDisconnect}
                  name='google'
                />
              }
              {
                isIdVerification == 1 && <Item
                  title={formatMessage(messages.documents)}
                  content={formatMessage(messages.documentVerificationDetails)}
                  isImage={true}
                  name='document'
                />
              }
            </div>
          </>
        }

        {
          displayUnVerifiedPanel && <>
            <h4 className={cx(cs.commonTotalText, cs.fontWeightBold, { [cs.paddingBottom2]: allUnverified }, { [cs.paddingBottom4]: displayVerifiedPanel })}>{formatMessage(messages.notVerifiedInfo)}</h4>
            {
              !isEmailConfirmed && !isGoogleConnected && isIdVerification != 1 &&
              <p className={cx(cs.paddingBottom4, s.marginBottmNone)}><FormattedMessage {...messages.notVerifiedDetails} /></p>
            }
            <div className={cx(s.cardSecBg)}>
              {
                !isEmailConfirmed && !pendingEmailChange && <Item
                  title={formatMessage(messages.emailLabel)}
                  content={formatMessage(messages.pleaseVerify)}
                  isAction
                  isLink={false}
                  buttonLabel={formatMessage(messages.verify)}
                  handleClick={this.sendConfirmEmail}
                  show={resendEmailLoading}
                  name='email'
                />
              }
              {
                !isGoogleConnected && <Item
                  title={formatMessage(messages.google)}
                  content={`${formatMessage(messages.googleInfo1)} ${siteName} ${formatMessage(messages.googleInfo2)}`}
                  isAction
                  isLink
                  buttonLabel={formatMessage(messages.connect)}
                  url={"/login/google"}
                  name='google'
                />
              }
              {
                isIdVerification != 1 && <Item
                  title={formatMessage(messages.documents)}
                  content={formatMessage(messages.documentVerificationInfo)}
                  isAction
                  buttonLabel={formatMessage(messages.verify)}
                  handleClick={this.documentVerification}
                  name='document'
                />
              }
            </div>
          </>
        }
      </div>
    );
  }
}

const mapState = (state) => ({
  resendEmailLoading: state.loader.resendEmailLoading,
  account: state.account.data,
  siteName: state.siteSettings.data.siteName
});

const mapDispatch = {
  disconnectVerification,
  resendEmailVerification
};

export default injectIntl(withStyles(s)(connect(mapState, mapDispatch)(MenuComponent)));
